import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import search1 from "../../../Components/assets/icons/search.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { Toaster } from "react-hot-toast";
import AddBrand from "./Add";
import EditBrand from "./Edit";
import ModalDelete from "../../common/ModelDelete";
import { EditButton, DeletButton } from "../../common/Button";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import { useLoader } from "../../../utils/common";

const API_URL = "/admin/about-us/brands";

// Permission ids: leave null until you create them in your role/permission table (null = allowed)
const PERM = { add: null, edit: null, delete: null };
const can = (isAllow, id) => id == null || isAllow?.includes(id);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    Per_Page_Dropdown,
    IMG_URL,
    isAllow,
  } = useContext(Context);
  const { withLoader } = useLoader();

  const [data, setData] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [option, setOption] = useState();
  const [reload, setReload] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [editId, setEditId] = useState(0);
  const [del, setDel] = useState(null); // { id, name }

  const getDataAll = async (p = page, term = search) => {
    const response = await withLoader(() =>
      getData(`${API_URL}?page=${p}&per_page=${perPage}&term=${encodeURIComponent(term || "")}`)
    );
    setData(response?.data || {});
    setOption(await Per_Page_Dropdown(response?.data?.total));
  };

  useEffect(() => {
    getDataAll();
    // eslint-disable-next-line
  }, [page, perPage, reload]);

  const list = data?.data || [];
  const total = data?.total || 0;
  const from = total ? (page - 1) * perPage + 1 : 0;
  const to = Math.min(page * perPage, total);

  const short = (text, n = 100) => (text ? (text.length > n ? `${text.slice(0, n)}…` : text) : "");

  const changeStatus = async (id) => {
    await editStatusData(`${API_URL}/${id}`);
    setReload((r) => !r);
  };

  const confirmDelete = async () => {
    const target = del;
    setDel(null);
    if (!target) return;
    await deleteData(`${API_URL}/${target.id}`);
    ErrorNotify(target.name);
    setReload((r) => !r);
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Brands & Collaborations"} link={"/about-us/brands"} />
        <section className="AdvanceDashboard">
          <div className="row me-0 ms-0">
            <div className="col-xxl-12 col-xl-12">
              <div className="MainRowsec ms-0 me-0">
                <section className="Tabels tab-radio">
                  <div className="row">
                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mb-2">
                      <div className="add">
                        {can(isAllow, PERM.add) && (
                          <Link type="button" className="btn btn-add pe-3">
                            <div onClick={() => setShowAdd(true)}>
                              <img src={plus} className="plus me-2 ms-0" alt="" />
                              Add Brand
                            </div>
                          </Link>
                        )}
                      </div>
                    </div>

                    <div className="border-line mt-3"></div>
                    <div className="row mt-3">
                      <div className="col-12">
                        <div className="d-flex align-items-center mb-1">
                          <p className="show m-0 me-2">Show</p>
                          <div className="number me-2">
                            <select
                              className="form-select form-select-sm"
                              value={perPage}
                              onChange={(e) => {
                                setPage(1);
                                setPerPage(Number(e.target.value));
                              }}
                            >
                              {(option || [10]).map((o) => (
                                <option key={o} value={o}>
                                  {o}
                                </option>
                              ))}
                            </select>
                          </div>
                          <p className="show m-0">entries</p>
                          <p className="show m-0 ms-3">{`Showing ${from} to ${to} of ${total} entries`}</p>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="row align-items-start">
                          <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-2">
                            <div className="num">
                              <label className="form-label"></label>
                              <input
                                type="text"
                                className="form-control"
                                value={search}
                                placeholder="Search brand or tagline"
                                onChange={(e) => setSearch(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    setPage(1);
                                    getDataAll(1, search);
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-xxl-1 col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12 mb-2">
                            <Form.Label>Search</Form.Label>
                            <div className="Search">
                              <Button
                                type="button"
                                className="btn btn-search"
                                onClick={() => {
                                  setPage(1);
                                  getDataAll(1, search);
                                }}
                              >
                                <img src={search1} className="search" alt="" />
                              </Button>
                            </div>
                          </div>
                          <div className="col-xxl-1 col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12 mb-2">
                            <Form.Label>Reset</Form.Label>
                            <div className="Search-1">
                              <button
                                type="button"
                                className="btn btn-reset"
                                onClick={() => {
                                  setSearch("");
                                  setPage(1);
                                  getDataAll(1, "");
                                }}
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr>
                            <th className="sr">Sr. No.</th>
                            <th className="tax-name">ID</th>
                            <th className="tax-name">Order</th>
                            <th className="tax-name">Brand</th>
                            <th className="tax-name">Tagline</th>
                            <th className="tax-name">Image</th>
                            <th className="tax-name">Logo</th>
                            <th className="tax-name">Status</th>
                            <th className="active">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {list.length > 0 ? (
                            list.map((d, index) => (
                              <tr key={d.id}>
                                <td>{(page - 1) * perPage + index + 1}.</td>
                                <td>{d.id}</td>
                                <td>{d.sort_order}</td>
                                <td>{d.name}</td>
                                <td>{short(d.tagline, 60)}</td>
                                <td>
                                  {d.image ? (
                                    <img src={IMG_URL + d.image} alt="" width="50" height="50" style={{ objectFit: "cover", borderRadius: 6 }} />
                                  ) : (
                                    <span className="text-muted">No image</span>
                                  )}
                                </td>
                                <td>
                                  {d.logo ? (
                                    <img src={IMG_URL + d.logo} alt="" width="50" height="50" style={{ objectFit: "contain", borderRadius: 6 }} />
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </td>
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      checked={!!d.status}
                                      disabled={!can(isAllow, PERM.edit)}
                                      onChange={() => changeStatus(d.id)}
                                      id={`brand-status-${d.id}`}
                                    />
                                    <label className="form-check-label" htmlFor={`brand-status-${d.id}`}>
                                      {d.status ? "Active" : "Inactive"}
                                    </label>
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex">
                                    {can(isAllow, PERM.edit) && (
                                      <EditButton handleShow1={(id) => setEditId(id)} id={d.id} />
                                    )}
                                    {can(isAllow, PERM.delete) && (
                                      <DeletButton
                                        showDeleteRecord={(id, name) => setDel({ id, name })}
                                        id={d.id}
                                        name={d.name}
                                      />
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9" className="text-center">
                                Data not available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      {list.length > 0 && (
                        <Pagination_Holder
                          handlePageChange={setPage}
                          onPageChange={page}
                          totalPages={data?.total_pages}
                        />
                      )}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>

      {showAdd && (
        <AddBrand
          handleClose={() => {
            setShowAdd(false);
            setReload((r) => !r);
          }}
        />
      )}

      {editId ? (
        <EditBrand
          id={editId}
          handleClose={() => {
            setEditId(0);
            setReload((r) => !r);
          }}
        />
      ) : null}

      <ModalDelete
        show={!!del}
        handleDeleteRecord={confirmDelete}
        handleDeleteCancel={() => setDel(null)}
      />
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;